import React from 'react';
import Lozenge from '@atlaskit/lozenge';

interface Props {
  credittype: string;
}

export const InvoiceRefundCreditNote = ({ credittype }: Props) => {
  let noteType;

  switch (credittype) {
    case 'full-item-refund':
      noteType = 'FULL REFUND';
      break;
    case 'tax-only-refund':
      noteType = 'TAX REFUND';
      break;
    case 'partial-item-refund':
      noteType = 'PARTIAL REFUND';
      break;
    default:
      noteType = credittype?.split('-').join(' ').toUpperCase();
  }
  return (
    <Lozenge appearance="inprogress" isBold={false}>
      {' '}
      {noteType}
    </Lozenge>
  );
};
